// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"4f448e90","486":"b451c20c","814":"d5b6edad"}[chunkId] + ".css";
};